import { ReactElement } from 'react';
import classnames from 'classnames';
import Card, { PrimaryContent } from '../../Card/Card';
import { Headline6 } from '../../Typography/Typography';
import List, {
	ListItem,
	MDCListItemGraphic as ListItemGraphic,
	MDCListItemText as ListItemText,
} from '../../List/List';
import Icon from '../Icon';
import { CSS_CLASSES } from './_constants';

import './IconLegend.scss';

/**
 * Functional component for rendering a legend of icons in {icon, text} format.
 * @param {Object} props JSX attributes passed to component.
 * @returns {ReactElement} rendered component.
 */
const iconLegend = props => {
	return (
		<Card small className={CSS_CLASSES.ROOT}>
			<PrimaryContent className={CSS_CLASSES.CONTENTS}>
				<Headline6>Key</Headline6>
				<List dense nonInteractive xlarge>
					{props.icons &&
						props.icons.map((icon, index) => (
							<ListItem key={index}>
								<ListItemGraphic
									className={classnames(
										icon.className,
										CSS_CLASSES.KEY
									)}
									graphic={<Icon icon={icon.Key} />}
								/>
								<ListItemText
									primaryText={icon.Value.toUpperCase()}
								/>
							</ListItem>
						))}
				</List>
			</PrimaryContent>
		</Card>
	);
};

export { iconLegend };
